import * as React from "react";
function SvgIcSortAscending(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.398 9.848l.375-.65-4.646-2.682-4.646 2.683.375.649 3.896-2.25v9.185h.75V7.599l3.896 2.249z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcSortAscending;
